export const FULL_REPAYMENT_BUFFER_PERCENTAGE = 0.001;
